import { gql } from "@apollo/client";

// Webtop file system ("This PC"). Three drives via `scope`: personal /
// organization / department. All operations are scoped server-side from the JWT
// (id + department). Folders/files live in the dashboard; files keep an S3 url
// (binary uploaded via the /upload route).

const FIELDS = `
  id
  scope
  parentId
  name
  type
  content
  url
  mimeType
  size
  special
  trashed
  createdAt
  updatedAt
`;

export const GET_WEBTOP_FILES = gql`
  query GetWebtopFiles($scope: String, $parentId: String) {
    getWebtopFiles(scope: $scope, parentId: $parentId) {
      ${FIELDS}
    }
  }
`;

export const GET_WEBTOP_STORAGE = gql`
  query GetWebtopStorage {
    getWebtopStorage {
      scope
      used
    }
  }
`;

export const GET_WEBTOP_FILE = gql`
  query GetWebtopFile($id: String!) {
    getWebtopFile(id: $id) {
      ${FIELDS}
    }
  }
`;

export const CREATE_WEBTOP_NODE = gql`
  mutation CreateWebtopNode(
    $name: String!
    $type: String!
    $scope: String
    $parentId: String
    $content: String
    $url: String
    $mimeType: String
    $size: Float
  ) {
    createWebtopNode(
      name: $name
      type: $type
      scope: $scope
      parentId: $parentId
      content: $content
      url: $url
      mimeType: $mimeType
      size: $size
    ) {
      ${FIELDS}
    }
  }
`;

export const COPY_WEBTOP_NODE = gql`
  mutation CopyWebtopNode($id: String!, $targetScope: String!, $targetParentId: String) {
    copyWebtopNode(id: $id, targetScope: $targetScope, targetParentId: $targetParentId) {
      ${FIELDS}
    }
  }
`;

export const UPDATE_WEBTOP_NODE = gql`
  mutation UpdateWebtopNode($id: String!, $name: String, $content: String, $parentId: String) {
    updateWebtopNode(id: $id, name: $name, content: $content, parentId: $parentId) {
      ${FIELDS}
    }
  }
`;

export const DELETE_WEBTOP_NODE = gql`
  mutation DeleteWebtopNode($id: String!) {
    deleteWebtopNode(id: $id)
  }
`;

export const GET_WEBTOP_DESKTOP_FOLDER = gql`
  query GetWebtopDesktopFolder {
    getWebtopDesktopFolder {
      ${FIELDS}
    }
  }
`;

export const GET_WEBTOP_TRASH = gql`
  query GetWebtopTrash {
    getWebtopTrash {
      ${FIELDS}
    }
  }
`;

export const RESTORE_WEBTOP_NODE = gql`
  mutation RestoreWebtopNode($id: String!) {
    restoreWebtopNode(id: $id) {
      ${FIELDS}
    }
  }
`;

export const PURGE_WEBTOP_NODE = gql`
  mutation PurgeWebtopNode($id: String!) {
    purgeWebtopNode(id: $id)
  }
`;

export const EMPTY_WEBTOP_TRASH = gql`
  mutation EmptyWebtopTrash {
    emptyWebtopTrash
  }
`;
